module.exports = __webpack_public_path__ + "static/media/cruve.af4e3e42.png";